import customImg from '../../../img/custom.png';
import itImg from '../../../img/IT.png';
import digitalImg from '../../../img/digital.png';
import uiuxImg from '../../../img/UI_UX.png';
import qaImg from '../../../img/QA.png';



const services = [
  {
    num: '01',
    title: 'CUSTOM',
    sub: 'SOFTWARE DEV',
    desc: 'We design and build tailor-made web and mobile applications — from MVPs to enterprise-grade platforms. Clean code, scalable architecture, on-time delivery.',
    color: 'bg-[#FF6B35]',
    textColor: 'text-white',
    img: customImg,
    icon: 'ri-code-s-slash-line',
  },
  {
    num: '02',
    title: 'IT',
    sub: 'CONSULTING',
    desc: 'We help businesses make smart technology decisions — auditing existing systems, planning digital transformation, selecting the right stack, and optimising processes.',
    color: 'bg-[#1A1A1A]',
    textColor: 'text-white',
    img: itImg,
    icon: 'ri-lightbulb-line',
  },
  {
    num: '03',
    title: 'DIGITAL',
    sub: 'MARKETING',
    desc: 'We develop promotion strategies, strengthen brand presence, and help products find their audience — SEO, paid ads, social media, content, and analytics.',
    color: 'bg-[#C4F547]',
    textColor: 'text-black',
    img: digitalImg,
    icon: 'ri-bar-chart-line',
  },
  {
    num: '04',
    title: 'UI/UX',
    sub: 'DESIGN',
    desc: 'Our designers craft intuitive, beautiful interfaces backed by user research. We turn complex products into seamless experiences that users love and convert.',
    color: 'bg-[#FF8C42]',
    textColor: 'text-white',
    img: uiuxImg,
    icon: 'ri-pencil-ruler-2-line',
  },
  {
    num: '05',
    title: 'QA &',
    sub: 'TESTING',
    desc: 'Every product we touch goes through rigorous quality assurance — manual and automated testing, load testing, security checks, and cross-device validation.',
    color: 'bg-[#FFD93D]',
    textColor: 'text-black',
    img: qaImg,
    icon: 'ri-shield-check-line',
  },
];

export default function ProductionSection() {
  return (
    <section id="services" className="bg-white py-24 md:py-36 overflow-hidden">
      <div className="px-8 md:px-16 mb-16">
        <div className="flex flex-col lg:flex-row items-start gap-6">
          <span
            className="text-[#FFD93D] font-black leading-none select-none flex-shrink-0"
            style={{ fontFamily: "'Bebas Neue', sans-serif",marginTop: '-12px', fontSize: 'clamp(80px, 16vw, 236px)', lineHeight: 1 }}
          >
            02
          </span>
          <div>
            <h2
              className="text-black font-black uppercase leading-none"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(40px, 7vw, 100px)' }}
            >
              WHAT
              <br />
              WE DO
            </h2>
            <p className="text-black/60 font-bold text-xl md:text-2xl mt-4 uppercase tracking-widest">
              Full-spectrum digital expertise — from concept to launch.
            </p>
          </div>
        </div>
      </div>

      {/* Horizontal scroll cards */}
      <div className="flex gap-6 px-8 md:px-16 overflow-x-auto pb-8" style={{ scrollbarWidth: 'none' }}>
        {services.map((s) => (
          <div
            key={s.num}
            className={`flex-shrink-0 w-[320px] md:w-[380px] rounded-[40px] overflow-hidden ${s.color} flex flex-col`}
            style={{ minHeight: '580px' }}
          >
            <div className="p-8 flex-1 flex flex-col">
              <div className="flex items-start justify-between mb-6">
                <span
                  className={`font-black ${s.textColor} opacity-20`}
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '80px', lineHeight: 1 }}
                >
                  {s.num}
                </span>
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-black/10`}>
                  <i className={`${s.icon} ${s.textColor} text-3xl`} />
                </div>
              </div>
              <h3
                className={`font-black uppercase ${s.textColor} leading-none mb-2`}
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(36px, 4vw, 52px)' }}
              >
                {s.title}
              </h3>
              <p
                className={`font-bold uppercase tracking-widest text-lg mb-4 ${s.textColor} opacity-70`}
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                {s.sub}
              </p>
              <p className={`${s.textColor} opacity-80 text-base md:text-lg leading-relaxed`}>
                {s.desc}
              </p>
            </div>
            <div className="w-full h-56 overflow-hidden flex items-center justify-center">
              <img
                src={s.img}
                alt={s.title}
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
